"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationCountry = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let LocalizationCountry = class LocalizationCountry {
    constructor(name, createdBy, updatedBy, description, isoCode, locale, currencyCode, currencyDisplayName, currencyFormat, numberFormat, dateFormat) {
        this.name = name;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.description = description;
        this.isoCode = isoCode;
        this.locale = locale;
        this.currencyCode = currencyCode;
        this.currencyDisplayName = currencyDisplayName;
        this.currencyFormat = currencyFormat;
        this.numberFormat = numberFormat;
        this.dateFormat = dateFormat;
    }
};
exports.LocalizationCountry = LocalizationCountry;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], LocalizationCountry.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "name", type: "varchar", nullable: false }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "iso_code", type: "varchar", length: 10, nullable: true }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "isoCode", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "locale", type: "varchar", length: 20, nullable: true }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "locale", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "currency_code", type: "varchar", length: 10, nullable: true }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "currencyCode", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "currency_display_name", type: "varchar", length: 50, nullable: true }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "currencyDisplayName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "currency_format", type: "varchar", length: 50, nullable: true }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "currencyFormat", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "number_format", type: "varchar", length: 50, nullable: true }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "numberFormat", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "date_format", type: "varchar", length: 20, nullable: true }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "dateFormat", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], LocalizationCountry.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], LocalizationCountry.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar", length: 100, nullable: false }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar", length: 100, nullable: false }),
    tslib_1.__metadata("design:type", String)
], LocalizationCountry.prototype, "updatedBy", void 0);
exports.LocalizationCountry = LocalizationCountry = tslib_1.__decorate([
    (0, typeorm_1.Entity)("localization_country"),
    tslib_1.__metadata("design:paramtypes", [String, String, String, String, String, String, String, String, String, String, String])
], LocalizationCountry);
